import { lazySelector } from '@phx-styleguides/core';

import { ScrollSpy } from '@sg-core/src/View/Components/Atoms/ScrollSpy/scroll-spy';

export class Faq {
  public el: HTMLElement;
  private anchorElements: NodeListOf<HTMLElement> | null = null;
  private scrollSpy: ScrollSpy | null = null;

  constructor(el: string | HTMLElement) {
    this.el = lazySelector(el);

    this.init();
  }

  init() {
    this.anchorElements = this.el.querySelectorAll('[data-anchor-target]');

    this.setupClickHandlers();
    this.setupScrollSpy();
  }

  private setupClickHandlers() {
    if (!this.anchorElements) {
      return;
    }

    this.anchorElements.forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();

        if (!event.target) {
          return;
        }

        const categoryEl = (event.target as HTMLElement).closest('[data-anchor-target]') as HTMLElement | null;

        if (!categoryEl || !categoryEl.dataset.anchorTarget) {
          return;
        }

        const target = document.querySelector(categoryEl.dataset.anchorTarget);

        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  private setupScrollSpy() {
    this.scrollSpy = new ScrollSpy(this.el, {
      anchorSelector: '[data-anchor-target]',
      rootMargin: '-20% 0px -60% 0px',
      activeClass: 'is-active',
      useAriaCurrent: true,
    });
  }

  public destroy() {
    if (this.scrollSpy) {
      this.scrollSpy.destroy();
      this.scrollSpy = null;
    }
  }
}
